import { createFileRoute } from "@tanstack/react-router";
import type { FermentationGroupId } from "@brewbase/db/types";
import { TestsSection } from "@/features/fermentation-journal/components/results/tests-section";

export const Route = createFileRoute("/fermentations/$group_id/results/tests")({
  component: TestsPage,
});

function TestsPage() {
  const { group_id } = Route.useParams();
  const groupId = Number(group_id) as FermentationGroupId;

  return (
    <div className="absolute inset-0 flex flex-col">
      <TestsSection groupId={groupId} />
    </div>
  );
}
